import {DatePipe} from '@angular/common';
import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {
    FormBuilder,
    FormControl,
    FormGroup,
    Validators,
} from '@angular/forms';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {NgbCalendar, NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';
import {AuthWebService} from 'app/services/authweb.service';
import {CarrierTypeService} from 'app/services/carrier-type.service';
import {CarrierService} from 'app/services/carrier.service';
import {CountryService} from 'app/services/country.service';
import {GooglePlacesSearchService} from 'app/services/google-places-search.service';
import {
    CountryISO,
    SearchCountryField,
    TooltipLabel,
} from 'app/shared/projects/ngx-intl-tel-input/src/public_api';
import {ToastNotificationService} from 'app/shared/toast-notification/toast-notification.service';
import {CarrierDriverService} from '../service/carrier-driver.service';
import {validateID} from '../../validators/south_african_id_customizer';
import { environment } from 'environments/environment';
import { DocumentsServiceService } from 'app/services/documents-service.service';
import { DocumenttypeService } from 'app/services/documenttype.service';
import { ConfirmDialogService } from 'app/services/shared/confirm-dialog/confirm-dialog.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'app-carrier-driver-add',
    templateUrl: './carrier-driver-add.component.html',
    styleUrls: ['./carrier-driver-add.component.scss'],
})
export class CarrierDriverAddComponent implements OnInit {
    driverForm: FormGroup;
    @Input() carrierId: any;
    @Input() driverId: any;
    @Output() saved = new EventEmitter();
    depots: any;
    isLoading: boolean = false;
    user: any = {};
    carrierDetails: any = [];
    driversDetails: boolean=false;
    branches: any = [];
    driverDetails = [];
    ddlCountries = [];
    dob:any;
    pdfSrc: any;
    isViewMode: boolean = false;
    img: any;
    isLoadingImg = false;
    homeaffairsReadOnly: boolean = false;
    minValidityDate:any;
    maxDOB: any;


    idTypes = [
        {key: 1, value: 'ID Number'},
        {key: 2, value: 'Foreign Passport / ID Number'},
    ];
    licenseTypes = [
        {key: 'Code A', value: 'Code A driver’s licence – for motorcycles'},
        {key: 'Code B', value: 'Code B driver’s licence – light motor vehicles'},
        {key: 'Code C', value: 'Code C driver’s licence – heavy motor vehicles'},
        {key: 'Code D', value: 'Code D driver’s licence – combination and articulated vehicles'},
    ];

    genderTypes = [
        {key: 'Male', value: 'Male'},
        {key: 'Female', value: 'Female'},
        {key: 'NA', value: 'Prefer Not To Say'},
    ];

    depotTypes = [
        {key: 'Freight', value: 'Freight'},
        {key: 'Passenger', value: 'Passenger'},
    ];
idTypeClicks = [];
    separateDialCode = true;
    SearchCountryField = SearchCountryField;
    TooltipLabel = TooltipLabel;
    CountryISO = CountryISO;
    defaultCountry: any = CountryISO.SouthAfrica;
    defaultCountryPhone: any = CountryISO.SouthAfrica;
    preferredCountries: CountryISO[] = [
        CountryISO.Angola,
        CountryISO.Botswana,
        CountryISO.Comoros,
        CountryISO.CongoDRCJamhuriYaKidemokrasiaYaKongo,
        CountryISO.Lesotho,
        CountryISO.Madagascar,
        CountryISO.Malawi,
        CountryISO.Mauritius,
        CountryISO.Mozambique,
        CountryISO.Namibia,
        CountryISO.Seychelles,
        CountryISO.Swaziland,
        CountryISO.Zambia,
        CountryISO.Zimbabwe,
    ];

    placesPredictions: any = [];
    isPlacesPredictionVible = false;
    placesPostalPredictions: any = [];
    isPostalPlacesPredictionVible = false;
    _type: any;
    errorField: any = {
        first_name: 'First Name is required',
        last_name: 'Last Name is required',
        id_number: 'ID Number is required',
        
        cellphone: 'Mobile Number is incorrect',
        id_type_ind: 'ID Type is required',
        depot_id: 'Depot Name is required',
        date_of_birth: 'Date of birth is required',
        gender: 'Gender is required',
        license_number: 'License Number is required',
        license_type: 'License Type is required',
    };
    foreignErrorField: any = {
        passport_number: 'Passport Number is required',
        work_permit_number: 'Work Permit Number is required',
        work_permit_expiry_date: 'Work Permit Expiry Date is required',
        passport_country_id: 'Country is required',
        passport_expiry_date: 'Passport Expiry Date is required',
        traffic_register_number: 'Traffic Register Number (TRN) is required',
        trn_issue_date: 'TRN\'s date-of-issue is required',
    };
    filebytes: string;
    filename: string;
    filetype: string;
    filesize: string;
    filedescription: string;
    uploadedDocs:any = [];
    viewDocuments: any = [];
    maxMB: any = environment.authWebApi.systemData.Configurations.find(
      (p) => p.Code == "MaxUploadMB1"
    ).Value;
    UserDocuments: any;
    date_of_birth: any;
    passport_expiry_date: any;
    currentDate: any = {
      day: new Date().getDate(),
      month: new Date().getMonth() + 1,
      year: new Date().getFullYear(),
  };
    trn_issue_date:any;
    work_permit_expiry_date:any;
    constructor(
        private _fb: FormBuilder,
        private countryService: CountryService,
        private googleSearch: GooglePlacesSearchService,
        private _carrierService: CarrierDriverService,
        private _router: Router,
        private _carrierInfo: CarrierService,
        private authWebService: AuthWebService,
        private _carrierType: CarrierTypeService,
        private toastService: ToastNotificationService,
        private datePipe: DatePipe,
        private _documentType:DocumenttypeService,
    private documentService: DocumentsServiceService,
    private confirmDialogService: ConfirmDialogService,
    private calendar: NgbCalendar,
    private sanitizer: DomSanitizer,
    ) {
        this.user = this.authWebService.userData
            ? this.authWebService.userData.User
            : null;
     
    
    this.maxDOB = {day: new Date().getDate(), month: (new Date().getMonth() + 1), year: new Date().getFullYear() -18}
    this.minValidityDate = {day: new Date().getDate(), month: (new Date().getMonth() + 1), year: new Date().getFullYear()}
    }

    ngOnInit(): void {
        this.createDriverInfoForm();
        this.listCountries();
      
        if (this.carrierId) {
            this.getCarrierInfo();
            this.getDriversByCarrierId(this.carrierId);
        }
        if (this.driverId) {
            this.getdriverDetails();

        }
        this.driverDocsType();
       // this.trn_issue_date.valueChanges.subscribe(newValue => { console.log("newValue",newValue) });
    }



    driverDocsType(){
        this._documentType.getDriverDocsTypes().subscribe((x:any) =>{
          this.uploadedDocs = x.filter(x => x.code !== 'WP-OCAS' && x.code !== 'P-OCAS')
        })
      }

    getCarrierType(id) {
        this._carrierType.getById(id).subscribe((x: any) => {
            this._type = x.description;
        });
    }
    idChange(){
      if(this.driverForm.controls.id_type_ind.value == 1){
        this._documentType.getDriverDocsTypes().subscribe((x:any) =>{
          this.uploadedDocs = x.filter(x => x.code !== 'WP-OCAS' && x.code !== 'P-OCAS')
        })
          this.setHomeAffairDefaults();
      }
        if(this.driverForm.controls.id_type_ind.value == 2){
          this._documentType.getDriverDocsTypes().subscribe((x:any) =>{
            this.uploadedDocs = x;
          })
            this.deactivateHomeAffairs();
        }


      }

    getCarrierInfo() {
        this.isLoading = true;
        this._carrierInfo
            .getCompanyDetailsById(this.carrierId)
            .subscribe((res: any) => {
                console.log(res);
                if (res) {
                    this.carrierDetails = res;
                    this.getCarrierType(res.Carrier.carrier_type_id);
                }
                if (res && res.Branches) {
                    this.branches = res.Branches;
                }
                this.isLoading = false;
            });
    }

    getdriverDetails() {
        this.isLoading = true;
        this._carrierService
            .getDriverDetails(this.driverId)
            .subscribe((res: any) => {
                if (res) {
                    console.log("Driver Details",res);
                    this.driverDetails = res;
                    
                    let date: any = this.datePipe.transform(res.date_of_birth, 'yyyy/MM/dd');
                    console.log('date',date)
                   // this.driverForm.get('date_of_birth').setValue(date);
                    this.driverForm.get('date_of_birth').patchValue(date);
                    this.driverForm.get('date_of_birth').setErrors(null);
                  //  this.driverForm.get('date_of_birth').clearValidators();
                   // this.driverForm.get('date_of_birth').updateValueAndValidity();
                    this.date_of_birth = date;
                    if(res.work_permit_expiry_date != null){
                        let dateW: any = this.datePipe.transform(res.work_permit_expiry_date, 'yyyy/MM/dd');
                        this.driverForm.get('work_permit_expiry_date').patchValue(dateW);
                        this.driverForm.get('work_permit_expiry_date').setErrors(null);
                        this.work_permit_expiry_date=dateW;
                        console.log('this.work_permit_expiry_date',this.work_permit_expiry_date)
                    }
                    if(res.passport_expiry_date != null){
                        let dateP: any = this.datePipe.transform(res.passport_expiry_date, 'yyyy/MM/dd');
                       // this.driverForm.get('passport_expiry_date').setValue(dateP);
                        this.driverForm.get('passport_expiry_date').patchValue(dateP);
                        this.driverForm.get('passport_expiry_date').setErrors(null);
                        this.driverForm.get('passport_expiry_date').updateValueAndValidity();
                        this.passport_expiry_date = dateP;
                        console.log('passport date',this.passport_expiry_date)
                        
                    }
                    if(res.trn_issue_date != null){
                        let dateT: any = this.datePipe.transform(res.trn_issue_date, 'yyyy/MM/dd');
                        //this.driverForm.get('trn_issue_date').setValue(dateT);
                        this.driverForm.get('trn_issue_date').patchValue(dateT);
                        this.driverForm.get('trn_issue_date').setErrors(null);
                        
                        this.trn_issue_date=dateT;
                    }
                    if(res.id_type_ind === 1){
                        this.setHomeAffairDefaults();
                    }else{
                        this.deactivateHomeAffairs();
                        this.driversDetails=true;
                    }
                    this.driverForm.patchValue(this.driverDetails);
                    this.getCarrierExistingDocuments()
                    this.isLoading = false;
                }
            });
    }
 
  

    createDriverInfoForm() {
        this.driverForm = new FormGroup({
            depot_id: new FormControl(null, Validators.required),
            notes: new FormControl(null),
            passport_country_id: new FormControl(null),
            id_type_ind: new FormControl(null, Validators.required),
            id_number: new FormControl(null),
            passport_number: new FormControl(null),
            passport_expiry_date: new FormControl(null),
            first_name: new FormControl('', [
                Validators.required,
                Validators.maxLength(50),
            ]),
            last_name: new FormControl('', [
                Validators.required,
                Validators.maxLength(50),
            ]),
            date_of_birth: new FormControl(null, Validators.required),
            gender: new FormControl(null, Validators.required),
            cellphone: new FormControl('', [
              Validators.required,
              Validators.maxLength(100),
            ]),
            // is_active: true,
            license_number: new FormControl(null, Validators.required),
            license_type: new FormControl(null, Validators.required),
            traffic_register_number: new FormControl('', Validators.maxLength(100)),
            trn_issue_date: new FormControl(null, Validators.required),
            work_permit_number: new FormControl(null),
            work_permit_expiry_date: new FormControl(null),
        });

        const idNumberControl = this.driverForm.get('id_number');
        const dateOfBirthControl = this.driverForm.get('date_of_birth')
        const genderControl = this.driverForm.get('gender');
        const id_type_indControl = this.driverForm.get('id_type_ind')
        //
        id_type_indControl.valueChanges.subscribe(value => {
            console.log('id_type_indControl', value);
            if (id_type_indControl.value === '1') {
                idNumberControl.setValidators([Validators.required, validateID()]);
            } else {
                idNumberControl.setErrors(null);
                idNumberControl.clearValidators();
            }

            // Update the validation state of the FormControl
            idNumberControl.updateValueAndValidity();
        });


        idNumberControl.valueChanges.subscribe(value => {

            if (value?.length > 12) {
                let year = parseInt(value.substring(0, 2));
                const month = parseInt(value.substring(2, 4));
                const day = parseInt(value.substring(4, 6));
                const gender = parseInt(value.substring(6, 10));

                const isFemale = gender < 5000;

                if (isFemale) {
                    genderControl.patchValue('Female');
                } else {
                    genderControl.patchValue('Male');
                }

                if (year < 50) {
                  year += 2000;
                } else {
                  year += 1900;
                }
                let tempDate = new Date(
                    year,
                    month,
                    day
                );
                console.log("Date of Birth", tempDate)
                let dob = {day: tempDate.getDate(), month: tempDate.getMonth() , year: tempDate.getFullYear()}
                if (tempDate.getMonth() === 0) {
                  dob.month = 12; // December
                  dob.year -= 1; // Decrement the year by 1
                }
                console.log("Date of Birth", dob)
                dateOfBirthControl.setValue(dob);
                // this.getHomeAffairsCarrierDetails();
            }
        });
    }

    validateID(id: any): boolean {
        let id_number = id;
        let correct = true;

        if (id_number === 13) {
            // SA ID Number have to be 13 digits, so check the length
            if (
                id_number.length != 13 ||
                !(!isNaN(parseFloat(id_number)) && isFinite(id_number))
            ) {
                this.toastService.error(
                    'ID Number must be numeric and not longer than 13 characters',
                    'Driver'
                );
                this.driverForm.get('id_number').markAsDirty();
                correct = false;
                return;
            }
            // get first 6 digits as a valid date
            let tempDate = new Date(
                id_number.substring(0, 2),
                id_number.substring(2, 4) - 1,
                id_number.substring(4, 6)
            );

            let id_date =
                tempDate.getDate().toString().length < 2
                    ? '0' + tempDate.getDate().toString()
                    : tempDate.getDate().toString();
            let id_month =
                (tempDate.getMonth() + 1).toString().length < 2
                    ? '0' + (tempDate.getMonth() + 1).toString()
                    : (tempDate.getMonth() + 1).toString();
            let id_year = tempDate.getFullYear().toString().slice(-2);
           // let dob = new Date(id_year + '/' + id_month + '/' + id_date);
            // this.driverForm.patchValue({
            //     date_of_birth: this.datePipe.transform(dob, 'yyyy-MM-dd'),
            // });
            let dob = {day: tempDate.getDay(), month: tempDate.getMonth(), year: tempDate.getDate()}
            this.driverForm.patchValue({
              date_of_birth: dob,
            });
            if (
                !(
                    id_year == id_number.substring(0, 2).toString() &&
                    id_month == id_number.substring(2, 4).toString() &&
                    id_date == id_number.substring(4, 6).toString()
                )
            ) {
                correct = false;
            }
        } else {
            correct = false;
        }
    }


    ChangeCountry(event) {
        this.defaultCountry = event.iso2;
    }

    ChangeCountryPhone(event) {
        this.defaultCountryPhone = event.iso2;
    }

    listCountries = () => {
        // this.isLoading = true;
        this.countryService.listCountries().subscribe(
            (result: any) => {
                this.ddlCountries = result.filter((x) => x.code !== 'ZA');
                // this.isLoading = false;
                // console.log(this.ddlCountries);
            },
            (error) => {
                // this.isLoading = false;
                //console.log(error);
            }
        );
    };

    validateFields(flag) {
        // mandatory fields are controlled by 'Validators.required' in initForm()
        let comFlag: boolean = flag;
        Object.keys(this.driverForm.controls).forEach((field) => {
            const control = this.driverForm.get(field); // {2}
            control.markAsTouched({onlySelf: true}); // {3}
            if (control.invalid && !comFlag) {
                let fieldName: any = this.errorField[field];
                this.toastService.error(fieldName, 'Driver');
                control.markAsDirty();
                comFlag = true;
                return false;
            } else {
            }
        });
        return true;
    }

    foreignValidateFields(flag) {
        // mandatory fields are controlled by 'Validators.required' in initForm()
        let comFlag: boolean = flag;
        Object.keys(this.driverForm.controls).forEach((field) => {
            // {1}
            const control = this.driverForm.get(field); // {2}
            control.markAsTouched({onlySelf: true}); // {3}
            if (control.invalid && !comFlag) {
                let fieldName: any = this.foreignErrorField[field];
                console.log(fieldName);
                this.toastService.error(fieldName, 'Driver');
                control.markAsDirty();
                comFlag = true;
                return false;
            } else {
            }
        });
        return true;
    }

    checkForeign() {
        if (this.driverForm.value.id_type_ind == 2) {
            this.foreignValidateFields(false);
        }
    }

    submitForm() {
      console.log('saving');
        //this.isLoading = true;
        this.validatePhone(this.driverForm.value.cellphone);
        if (this.driverForm.value.id_type_ind == 1) {
            this.driverForm.get('id_number').setValidators([Validators.required]);

            this.driverForm.get('id_number').updateValueAndValidity();

            this.driverForm.get('passport_expiry_date').clearValidators();
            this.driverForm.get('passport_number').clearValidators();
            this.driverForm.get('work_permit_number').clearValidators();
            this.driverForm.get('work_permit_expiry_date').clearValidators();
            this.driverForm.get('passport_country_id').clearValidators();
            this.driverForm.get('traffic_register_number').clearValidators();
            this.driverForm.get('trn_issue_date').clearValidators();

            this.driverForm.get('passport_expiry_date').updateValueAndValidity();
            this.driverForm.get('passport_number').updateValueAndValidity();
            this.driverForm.get('work_permit_number').updateValueAndValidity();
            this.driverForm.get('work_permit_expiry_date').updateValueAndValidity();
            this.driverForm.get('passport_country_id').updateValueAndValidity();
            this.driverForm.get('traffic_register_number').updateValueAndValidity();
            this.driverForm.get('trn_issue_date').updateValueAndValidity();
        }
        if (this.driverForm.value.id_type_ind == 2) {
            this.driverForm
                .get('passport_expiry_date')
                .setValidators([Validators.required]);
            this.driverForm
                .get('passport_number')
                .setValidators([Validators.required]);
            this.driverForm
                .get('work_permit_number')
                .setValidators([Validators.required]);
            this.driverForm
                .get('work_permit_expiry_date')
                .setValidators([Validators.required]);
            this.driverForm
                .get('passport_country_id')
                .setValidators([Validators.required]);
                this.driverForm.get('traffic_register_number').setValidators([Validators.required]);
            this.driverForm.get('trn_issue_date').setValidators([Validators.required]);

            this.driverForm.get('id_number').clearValidators();
            this.driverForm.get('id_number').updateValueAndValidity();

            this.driverForm.get('passport_expiry_date').updateValueAndValidity();
            this.driverForm.get('passport_number').updateValueAndValidity();
            this.driverForm.get('work_permit_number').updateValueAndValidity();
            this.driverForm.get('work_permit_expiry_date').updateValueAndValidity();
            this.driverForm.get('passport_country_id').updateValueAndValidity();
            this.driverForm.get('work_permit_expiry_date').updateValueAndValidity();
            this.driverForm.get('trn_issue_date').updateValueAndValidity();
            this.driverForm.get('traffic_register_number').updateValueAndValidity();
        }
        
        
        if (!this.driverForm.valid) {
            this.isLoading = false;
            this.checkForeign();
            this.validateFields(false);
            return;
        }
          
        if (this.validateID(this.driverForm.get('id_number').value) == false) {
         
            return;
        }
        if(this.validatePhone(this.driverForm.value.cellphone) == true){
            return;
        }

        if (this.driverForm.value) {
          
            let obj = {...this.driverForm.value};
            obj.title = 'Mr.';
            if (obj.telephone) {
                obj.iso2_tele = obj.telephone.countryCode;
                obj.dial_code_tele = obj.telephone.dialCode;
                obj.telephone = obj.telephone.number;
            }
            if (obj.cellphone) {
                obj.iso2_cell = obj.cellphone.countryCode;
                obj.dial_code_cell = obj.cellphone.dialCode;
                obj.cellphone = obj.cellphone.number;
            }
            if (obj.trn_issue_date) {
                obj.trn_issue_date = this.onDateSelect(obj.trn_issue_date);
            }
            if (obj.date_of_birth) {
                obj.date_of_birth = this.onDateSelect(obj.date_of_birth);
            }
            if(obj.work_permit_expiry_date){
              obj.work_permit_expiry_date = this.onDateSelect(obj.work_permit_expiry_date);
            }
            if(obj.passport_expiry_date){
              obj.passport_expiry_date = this.onDateSelect(obj.passport_expiry_date);
            }


            console.log('documents');
            console.log(this.uploadedDocs);
            console.log(this.viewDocuments);
             var docs = this.uploadedDocs;
             var tobeSplice = this.uploadedDocs;
             console.log(tobeSplice)


            if(this.viewDocuments.length == 0){
              for(var i = 0;i<this.uploadedDocs.length;i++){
                return this.toastService.error(this.uploadedDocs[i].description+ ' is required!','Document Required')
              }
            }
            for(var i = 0;i<this.uploadedDocs.length;i++){
              for(var x = 0;x<this.viewDocuments.length;x++){
                if(docs[i].id == this.viewDocuments[x].document_type_id){
                  const index = docs.indexOf(docs[i]);
                  docs.splice(index, 1);
                }
              }
            }
            this.driverDocsType();
            if(docs.length > 0){
              for(let item  of docs) {
                return this.toastService.error(item.description+ ' is required!','Document Required')
             }
            }
            
            if (this.driverId) {
                obj.id = +this.driverId;
                obj.user_modified = this.user.FirstName;
                obj.date_modified = new Date();
                this._carrierService.updateDriver(obj).subscribe((response: any) => {
                    if (response) {
                        this.saved.emit(response);
                    }
                    this.isLoading = false;
                    this.toastService.success('Driver was updated successfully', 'Driver');
                }, (error) =>{
                  this.toastService.error('Unable to update Driver','Driver');
                });
            } else {
              
                obj.date_created = new Date();
                obj.user_created = this.user.FirstName;
                obj.id = this.driverId;
                obj.carrier_id = this.carrierId;
               // console.log('driver object save ' , obj);
                this._carrierService.addDriver(obj).subscribe((response: any) => {
                    if (response) {
                        this.saved.emit(response);
                    }
                    this.isLoading = false;
                    this.toastService.success('Driver was added successfully', 'Driver');
                }, (error) => {
                  this.toastService.error('Unable to add Driver','Driver');
              });
            }
            this.isLoading = false;
        }
    }

    // onDateSelect(date: NgbDateStruct) {
    //   console.log(date);
    //     const selectedDate = new Date(date.year, date.month - 1, date.day); // month is zero-based
    //     if(selectedDate.toString() == "Invalid Date"){
    //       return date;
    //     }
    //     const formattedDate = this.datePipe.transform(selectedDate, 'dd/MM/yyyy');
        
    //     return formattedDate;
    // }
    onDateSelect(date) {
      let selectedDate;
  
      if (this.isValidDate(date)) {
          selectedDate = new Date(date);
      } else {
          selectedDate = new Date(date.year, date.month - 1, date.day); // month is zero-based
      }
  
      const formattedDate = this.datePipe.transform(selectedDate, 'yyyy/MM/dd');
      this.driverForm.value.date_of_birth = formattedDate;
      return formattedDate;
  }
  
  isValidDate(date: any): boolean {
      const parsedDate = new Date(date);
      return parsedDate.toString() !== 'Invalid Date' && !isNaN(parsedDate.getTime());
  }

    onClickBack() {
        this.saved.emit('true');
    }

    getDriversByCarrierId(id) {
        this._carrierService.getDriversByCarrierId(id).subscribe((x) => {
            this.depots = x;
        });
    }

    extractIDInfo(idNumber: any) {
        console.log("extractIDInfo", idNumber);
    }

    //Freight/Passenger/Both
    getCarrierTypeByIndex(index) {

    }
    
    numbersOnly(event): boolean {
        const charCode = (event.which) ? event.which : event.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            return false;
        }
        return true;
    }
    validatePhone(value:any):boolean{
        if ((value && value.countryCode == "ZA" && value.number.length <= 9)) {
         
          return true;
        }
        return false;
        
      }
      onChange(value) {
          this.driverForm.patchValue({
              id_number: '', first_name: '', last_name: '', date_of_birth: '', gender: ''
          });
        this.idTypeClicks.push(value);
        console.log(this.idTypeClicks.length);
        if(this.idTypeClicks.length > 1){
           // this.resetDriverInfoForm(value)
        }
        this.idChange();
    }
    resetDriverInfoForm(id) {
        this.driverForm = new FormGroup({
            depot_id: new FormControl(null, Validators.required),
            notes: new FormControl(null),
            passport_country_id: new FormControl(null),
            id_type_ind: new FormControl(id, Validators.required),
            id_number: new FormControl(null),
            passport_number: new FormControl(null),
            passport_expiry_date: new FormControl(null),
            first_name: new FormControl('', [
                Validators.required,
                Validators.maxLength(50),
            ]),
            last_name: new FormControl('', [
                Validators.required,
                Validators.maxLength(50),
            ]),
            date_of_birth: new FormControl(null, Validators.required),
            gender: new FormControl(null, Validators.required),
            cellphone: new FormControl('', [
              Validators.required,
              Validators.maxLength(100),
            ]),
            // is_active: true,
            license_number: new FormControl(null, Validators.required),
            license_type: new FormControl(null, Validators.required),
            traffic_register_number: new FormControl('', Validators.maxLength(100)),
            trn_issue_date: new FormControl(null, Validators.required),
            work_permit_number: new FormControl(null),
            work_permit_expiry_date: new FormControl(null),
        });

        const idNumberControl = this.driverForm.get('id_number');
        const dateOfBirthControl = this.driverForm.get('date_of_birth')
        const genderControl = this.driverForm.get('gender');
        const id_type_indControl = this.driverForm.get('id_type_ind')
        //
        id_type_indControl.valueChanges.subscribe(value => {
            console.log('id_type_indControl', value);
            if (id_type_indControl.value === '1') {
                idNumberControl.setValidators([Validators.required, validateID()]);
            } else {
                idNumberControl.setErrors(null);
                idNumberControl.clearValidators();
            }

            // Update the validation state of the FormControl
            idNumberControl.updateValueAndValidity();
        });


        idNumberControl.valueChanges.subscribe(value => {

            if (value?.length > 12) {
                const year = parseInt(value.substring(0, 2));
                const month = parseInt(value.substring(2, 4));
                const day = parseInt(value.substring(4, 6));
                const gender = parseInt(value.substring(6, 10));
                const dateOfBirth = new Date(year + 1900, month - 1, day);
                const isFemale = gender < 5000;

                if (isFemale) {
                    genderControl.patchValue('Female');
                } else {
                    genderControl.patchValue('Male');
                }
                dateOfBirthControl.setValue({
                    year:year,
                    month: month,
                    day: day
                });
            }
        });
    }
    
// handleFileInput(files: FileList) {
//     this.fileToUpload = files.item(0);
//     this.fileName = files.item(0).name;
//   }
  onFileSelected(event: any, documenttypeid: any) {
    this.setFileData(event, "upload", documenttypeid);
  }
  
  setFileData(event: any, description: any, documenttypeid: any) {
    if (documenttypeid != null) {
      const reader = new FileReader();
  
      if (event.target.files && event.target.files.length > 0) {
        let file: any = null;
        const count = event.target.files.length;
  
        file = event.target.files[count - 1];
        let result = this.checkFileType(file.name);
        let fileFound = false;
        this.viewDocuments.forEach(
          function (value) {
              if (event.target.files[0].name == value.file_name) {
                  fileFound = true;
              }
          }.bind(this)
      );
  
      if (fileFound) {
        this.toastService.error(
          `You already uploaded this file`,
          'File upload failed'
      );
          return;
      }
  
        //if File type is in not found
        if (result != -1) {
          let sizeresult = this.checkFileSize(file.size);
  
          if (sizeresult != -1) {
  
            reader.removeEventListener;
            reader.readAsDataURL(file);
            reader.onload = () => {
              this.filebytes = reader.result.toString().split(",")[1];
              (this.filename = file.name), (this.filetype = file.type);
              this.filedescription = description;
              this.filesize = file.size;
              this.validateData(documenttypeid);
            };
          } else {
            let allowedFileSize =
              environment.authWebApi.systemData.Configurations.find(
                (p) => p.Code == "MaxUploadMB1"
              );
            // this.dialogService.addDialog(ErrorComponent, { title: 'File Upload Failed, Please try again.', message: `Maximum file size allowed ${allowedFileSize.Value.toString()}MB`, statuscode: '404',url: null, servermessage: "File size exceeded maximum size"});
            this.toastService.error(
              `Maximum file size allowed ${allowedFileSize.Value.toString()}MB`,
              "File Upload Failed, Please try again."
            );
          }
        } else {
          //send message allowed types
          let allowedFileTypes =
            environment.authWebApi.systemData.Configurations.find(
              (p) => p.Code == "UploadDocTypes1"
            );
  
          // this.dialogService.addDialog(ErrorComponent, { title: 'File Upload Failed, Please try again.', message: `Only these file types are allowed: PDF  ${allowedFileTypes.Value.toString()}`, statuscode: '404',url: null, servermessage: "Extension not allowed"});
          this.toastService.error(
            `Only these file types are allowed: PDF`,
            "File Upload Failed, Please try again."
          );
        }
      }
  
      // this.showOtherUploadsOption = false;
    }
  }
  
  checkFileType(fileName: string) {
    // from the file name derive the extension
    let allowedFileTypes =
      environment.authWebApi.systemData.Configurations.find(
        (p) => p.Code == "UploadDocTypes1"
      );
    let fileTypesArray = allowedFileTypes.Value.toString().split(",");
    //check if file type is
    let ext = fileName.split(".")[1].toUpperCase();
    let count = fileTypesArray.length;
    for (let iter = 0; iter < count; iter++) {
      if (fileTypesArray[iter] == ext) return iter;
    }
    return -1;
  }
  
  checkFileSize(fileSize: number) {
    // get the maximum file size
    let allowedFileSize = environment.authWebApi.systemData.Configurations.find(
      (p) => p.Code == "MaxUploadMB1"
    );
    let maxAllowedSize = allowedFileSize.Value; //it is in MB
    let document_sizeMB = fileSize / 1000000;
    if (document_sizeMB <= maxAllowedSize) return 1;
    else return -1;
    //
  }
  validateData(documenttypeid: any) {
    // if(!this.driverForm.valid){
    //   return this.toastService.error("Please fill in all required fields on the form first!", "Warning");
    // }
    if(this.driverForm.controls.id_type_ind.value ==   null){
      return this.toastService.error("Please select id type first!", "Warning");
    }
    if(this.driverForm.controls.id_type_ind.value ==  1 && this.driverForm.value.id_number == null){
      return this.toastService.error("Please fill in id number first!", "Warning");
    }
    if(this.driverForm.controls.id_type_ind.value == 2 && this.driverForm.value.passport_number == null){
      return this.toastService.error("Please fill in your passport number first!", "Warning");
    }
    if (this.carrierId == null) {
      // this.dialogService.addDialog(AlertComponent, { title: 'Error', message: 'Unable to upload documents ' })
      this.toastService.error("Unable to upload documents ", "Error");
    } else {
      this.postFile(this.carrierId, documenttypeid);
    }
  }

    getHomeAffairsCarrierDetails() {

        let id_type = this.driverForm.get('id_type_ind').value;
        // if(id_type !== 2){
        //     return false;
        // }

        let id = this.driverForm.get('id_number').value;
        if(id){
            this._carrierInfo.getHomeAffairsCarrierDetails(id)
                .subscribe(
                    (response: any) => {
                        console.log('Home Affairs Carrier Details:', response);
                        if(response.Error === "0000"){
                            this.driverForm.patchValue({
                                id_number: response.Person.IdNumber, first_name: response.Person.Names, last_name: response.Person.Surname,
                            });
                            this.homeaffairsReadOnly = true;
                        }else if (response.Error === "0400"){
                            this.resetHomeAffairs()
                        }
                        else{
                            this.resetHomeAffairs()
                        }
                    },
                    (error) => {
                        this.toastService.error(`An error occurred when retrieving your details from Home Affairs`, 'Carrier Registration')
                    }
                );
        }else{
            this.toastService.error(`Please enter a valid SA ID`, 'Carrier Registration')
        }

    }

    resetHomeAffairs(){
        this.driverForm.controls['id_number'].setErrors({'invalid_id': true});
        this.driverForm.patchValue({
            id_number: '', first_name: '', last_name: '',
        });
        this.homeaffairsReadOnly = false;
        this.toastService.error(`Your ID was not found at Home Affairs, please ensure its correct`, 'Carrier Registration')
    }



    deactivateHomeAffairs() {
        this.homeaffairsReadOnly = false;
    }

    setHomeAffairDefaults() {
        this.homeaffairsReadOnly = true;
    }
  
  postFile(CarrierID: any, documenttypeid: any) {
    //this.uploader.nativeElement.value = ''
  
    const formdata = new FormData();
    formdata.append("File", this.filebytes);
    formdata.append("FileName", this.filename);
    formdata.append("TypeOfFile", this.filetype);
    formdata.append("FileSize", this.filesize);
    formdata.append("documenttypeid", documenttypeid);
    formdata.append("CarrierID", CarrierID);
    formdata.append("UserLastName", this.user.LastName);
    formdata.append("CarrierName", this.user.LastName);
    if(this.driverForm.controls.id_type_ind.value ==  1){
      formdata.append("Notes", this.driverForm.value.id_number);
    }
    if(this.driverForm.controls.id_type_ind.value == 2){
      formdata.append("Notes", this.driverForm.value.passport_number);
    }
    
  
  
    //this.isLoading = true;
  
  
    this.documentService
      .postDocument(formdata, documenttypeid, CarrierID)
      .subscribe(
        (response) => {
          //this.dialogService.addDialog(AlertComponent, {
          //    title: 'File Uploaded',
          //    message: 'File: ' + this.filename + ' was successfully uploaded.',
          //    bold: this.filename
          //})
          this.getCarrierExistingDocuments()
  
        },
        (error) => {
          this.isLoading = false;
           //console.log('error ', error);
          // this.dialogService.addDialog(ErrorComponent, {
          //     title: 'File Upload Failed, Please try again.',
          //     message: error._body , statuscode: error.Status, url: error.Uri, servermessage: error.Message
          // }),
          this.toastService.error(
            "Failed to upload please try again",
            " File Upload Error"
          );
        }
      );
  }
  onFileChange(event, documenttypeid) {
    let file: any = null;
    file = Object.keys(event).map((key) => event[key]);
    this.setDropFileData(file, "upload", documenttypeid);
  
    // this.toastr.info(`File uploaded successfully`, 'File Upload.');
  }
  setDropFileData(event: any, description: any, documenttypeid: any) {
    if (documenttypeid != null) {
      const reader = new FileReader();
  
      if (event && event.length > 0) {
        let file: any = null;
        const count = event.length;
  
        file = event[count - 1];
        let result = this.checkFileType(file.name);
        let fileFound = false;

  
        this.UserDocuments.forEach(
          function (value) {
            if (file.name == value.file_name) {
              fileFound = true;
              this.toastService.error(
                `You already uploaded this file`,
                "File upload failed"
              );
              return false;
            }
          }.bind(this)
        );
  
        if (fileFound) {
          return;
        }
  
        //if File type is in not found
        if (result != -1) {
          let sizeresult = this.checkFileSize(file.size);
  
          if (sizeresult != -1) {
  
            reader.removeEventListener;
            reader.readAsDataURL(file);
            reader.onload = () => {
              this.filebytes = reader.result.toString().split(",")[1];
              (this.filename = file.name), (this.filetype = file.type);
              this.filedescription = description;
              this.filesize = file.size;
              this.validateData(documenttypeid);
            };
          } else {
            let allowedFileSize =
              environment.authWebApi.systemData.Configurations.find(
                (p) => p.Code == "MaxUploadMB1"
              );
            // this.dialogService.addDialog(ErrorComponent, { title: 'File Upload Failed, Please try again.', message: `Maximum file size allowed ${allowedFileSize.Value.toString()}MB`, statuscode: '404',url: null, servermessage: "File size exceeded maximum size"});
            this.toastService.error(
              `Maximum file size allowed ${allowedFileSize.Value.toString()}MB`,
              "File Upload Failed, Please try again."
            );
          }
        } else {
          //send message allowed types
          let allowedFileTypes =
            environment.authWebApi.systemData.Configurations.find(
              (p) => p.Code == "UploadDocTypes1"
            );
  
          // this.dialogService.addDialog(ErrorComponent, { title: 'File Upload Failed, Please try again.', message: `Only these file types are allowed: PDF  ${allowedFileTypes.Value.toString()}`, statuscode: '404',url: null, servermessage: "Extension not allowed"});
          this.toastService.error(
            `Only these file types are allowed: PDF`,
            "File Upload Failed, Please try again."
          );
        }
      }
  
      // this.showOtherUploadsOption = false;
    }


  }
  getCarrierExistingDocuments() {
    this.isLoading = true;
    this.documentService.getByCarrierId(this.carrierId).subscribe(
      (result:any) => {
        if(this.driverForm.controls.id_type_ind.value ==  1){
          this.viewDocuments = result.filter(x => x.notes === this.driverForm.value.id_number);
        }
        if(this.driverForm.controls.id_type_ind.value == 2){
          this.viewDocuments = result.filter(x => x.notes === this.driverForm.value.passport_number);
        }
        console.log(this.viewDocuments)
        if (this.viewDocuments.length > 0) {
          // this.removeUploadedDocTypes();
        }
      },
      (error) => {
        this.viewDocuments = [];
  
        this.isLoading = false;
        // this.dialogService.addDialog(ErrorComponent, { title: 'Document Uploads', message: `Unable to retrieve carrier documents.`, statuscode: error.Status, url: error.Uri, servermessage: error.Message });
      }
    );

    this.isLoading = false;
  }
  onConfirm(doc: any) {
    // this.confirm.showYesNo('Delete Uploaded Document', `Are you sure you want to remove the file ${doc.file_name}  uploaded?`, null, 'Yes', 'No')
    //   .subscribe((isConfirmed) => {
    //     if (isConfirmed) {
    //       this.onDelete(doc)
    //     } else {
    //       return;
    //     }
    //   });
    this.confirmDialogService.confirmThis(
      `Are you sure you want to remove the file ${doc.file_name}  uploaded?`,
      () => {
        this.onDelete(doc);
      },
      () => {
        return;
      }
    );
  }
  onDelete(doc: any) {
    this.isLoading = true;
    this.documentService.delete(doc.id).subscribe(
      (result) => {
        // this.dialogService.addDialog(AlertComponent, { title: 'Delete Document', message: `Document ${this.removeRef.code} deleted.`, bold: `${this.removeRef.code}` });
        this.toastService.success(
          `Document ${doc.code} deleted.`,
          "Delete Document"
        );
       this.getCarrierExistingDocuments();
        //if (result != null) {
        // this.onNo();
        this.isLoading = false;
        //}
        //this.onChangeHeading();
      },
      (error) => {
        error = error.json();
        this.isLoading = false;
        // this.dialogService.addDialog(ErrorComponent, { title: 'Delete Document', message: `Document ${this.removeRef.code} was not deleted.`, statuscode: error.Status, url: error.Uri, servermessage: error.Message });
        this.toastService.error(
          `Document ${doc.code} was not deleted.`,
          "Delete Document"
        );
      }
    );
  }
  viewDoc(id, fileName) {
    //alert(id);
    //console.log(id)
    this.isViewMode = true;
    id = fileName.substring(fileName.indexOf("#") + 1);
    this.isLoadingImg = true;
    this.pdfSrc = null;
    this.img = null;
    let ext = fileName.substring(fileName.length - 3, fileName.length);
    //console.log(ext);
    if (fileName.includes(".pdf")) {
      this.documentService.downloadpdf(id).subscribe((x) => {
        console.log(x);

        let objectURL = URL.createObjectURL(x);
        this.pdfSrc = objectURL;
        console.log(this.pdfSrc);
        //alert(this.pdfSrc.toString());
        //this.pdfSrc = this.sanitizer.bypassSecurityTrustUrl(objectURL);
        //console.log(this.pdfSrc)
        this.isLoadingImg = false;
      });
      return;
    }

    this.documentService.download(id).subscribe((x) => {
      let objectURL = URL.createObjectURL(x);
      console.log(objectURL);
      this.pdfSrc = null;
      this.img = this.sanitizer.bypassSecurityTrustUrl(objectURL);
      console.log(this.img);
      this.isLoadingImg = false;
      // this.img = x;
    });
  }
  viewDoc1(documenlink, fileName) {
    const id = documenlink.toString().split("#")[1];
    this.isLoading = true;
    this.pdfSrc = null;
    this.img = null;
    let ext = fileName.substring(fileName.length - 3, fileName.length);
    this.documentService.downloadpdf(id).subscribe((x: File) => {
      let objectURL = URL.createObjectURL(x);
      this.pdfSrc = objectURL;
      this.isLoading = false;
    });
  }
  letterOnly(event) {
    var charCode = event.keyCode;

    if ((charCode > 64 && charCode < 91) || (charCode > 96 && charCode < 123) || charCode == 8)

      return true;
    else
      return false;
}

getMaxDate(): NgbDateStruct {
  const today = this.calendar.getToday();
 // return today;
 return this.minValidityDate;
}

formatDate(dateValue: any ,id: any): string {
  if (dateValue instanceof Date) {
      // If it's already a Date object, format it
      return dateValue.toISOString().slice(0, 10); // Format as 'yyyy-MM-dd'
  } else {

    if(dateValue == null){
      return '';
    }

      const parsedDate = new Date(dateValue.year, dateValue.month - 1, dateValue.day);
      if (!isNaN(parsedDate.getTime())) {
          return parsedDate.toISOString().slice(0, 10);
      } else {
          // Handle the case where the date value is not valid
          return ''; // or any default value you prefer
      }
  }
}

    changeBasicContactInfoParm() {
        // this.utility.checkFreight = this.form.controls.freight_passenger_ind.value;
        // if (this.status_id != 1) {
        //     return this.isBasicContactInfo = false;
        // }
    }


}
